<div class="p-6 pt-4">
    <h3 class="text-xl font-bold mb-2 text-shs-white-1 flex items-center gap-2">
        <span class="icon-circle-warning text-shs-yellow"></span> Delete Cod #{{ config.data?.id }}
    </h3>
    <p class="text-lg text-shs-white-1">Are you sure you want to delete this COD?</p>
    <div class="flex justify-end items-center gap-2 mt-8">
        <sag-ui-button color="secondary" size="sm" (click)="onClose()"> No </sag-ui-button>
        <sag-ui-button size="sm" (click)="onClose('cancel')"> Yes </sag-ui-button>
    </div>
</div>
